import { render, staticRenderFns } from "./CommissionLevels.vue?vue&type=template&id=2c8836eb&"
import script from "./CommissionLevels.vue?vue&type=script&lang=js&"
export * from "./CommissionLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports